import { RequestService } from './RequestService';

// The three exit-reason endpoints (server/src/routes/exitReasonRouter.js).
//
// listReasons is what keeps the six sentences in one place: the question is drawn from
// whatever the server returns, never from a list held in the front end.
//
// The two submit paths are deliberately separate methods rather than one with a flag,
// because they are not the same action. The first records an answer and sends no mail.
// The second is a cancellation request and does tell the team, which is why it is the one
// behind a token.
export class ExitReasonService extends RequestService {

    listReasons = () => this.request('get', 'reasons');

    submitFromGoodbyePage = (body) => this.request('post', 'submit', '', body);

    submitFromAccount = (body) => this.request('post', 'submit-from-account', '', body);
}
